import { takeEvery } from 'redux-saga/effects';
import type { Customer, PortfolioItem } from '@app/types';
import { TRANSACTION } from '../consts';
import isGAReady from '../utils/isGAReady';
import decorateAnalytics from '../utils/decorateAnalytics';
import { AnalyticsAttributes } from '../../consts';

interface transactionPayload {
  type: string;
  payload: {
    portfolioItem: PortfolioItem;
    customerType: 'Buyer' | 'Seller';
    customer: Customer;
    paymentMethod?: string | undefined;
  };
}

export const onTransaction = ({
  payload: { portfolioItem, customerType, paymentMethod, customer },
}: transactionPayload) => {
  if (!isGAReady()) {
    return;
  }

  const { product } = portfolioItem;

  window.ga('ec:addProduct', {
    id: product.uuid,
    name: product.title,
    brand: product.brand,
    category: product.productCategory,
    variant: product.colorway,
    price: portfolioItem.amount,
    quantity: 1,
  });

  window.ga('ec:setAction', 'purchase', {
    id: portfolioItem.chainId,
    affiliation: `${customerType} ${portfolioItem.customerId}`,
    revenue: portfolioItem.amount,
    coupon: portfolioItem.meta?.discountCode ?? '',
    productPrice: portfolioItem.amount,
  });

  window.ga('send', 'event', 'Ecommerce', 'Purchase', {
    nonInteraction: 1,
    ...(!!paymentMethod && {
      [AnalyticsAttributes.cdPaymentMethod]: paymentMethod,
    }),
    ...decorateAnalytics(
      {
        product,
        portfolioItem,
        customer,
      },
      'ga',
    ),
  });
};

export default function* transactionSaga() {
  yield takeEvery(TRANSACTION, onTransaction);
}
